module.exports = __webpack_public_path__ + "static/code-8eed76818df4211d65814e4bd1a8c22a.png";